// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3VcwG","divider":"styles_divider__KFXCJ","content":"styles_content__WPD3B"};